<template>
  <div id="app">
    <app-header v-if="!noheader"></app-header>
    <router-view/>
    <app-footer></app-footer>
    <error-banner></error-banner>
  </div>
</template>

<script>

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import errorBanner from '@/components/parts/error-banner'

  import router from '@/router';

  import {mapActions,mapGetters} from 'vuex';

  export default {
    name: 'App',
    mounted(){
      this.checkLogged().then( r => {
        if(!r){
          router.push({name : 'login'});
        }else{
          setTimeout(e => {
            if(!!this.logged && this.$route.name != 'encuesta'){
              this.initApp();
            }
          },300)
        }
      });


    },
    components : {
      'app-header' : header,
      'app-footer' : footer,
      'error-banner' : errorBanner,
      'cookie-law' : CookieLaw
    },
    computed:{
      noheader(){
        let forbbiden = ['login','datosseguridadsocial','politicaprivacidadseguridadsocial'];
        return (forbbiden.some(e => e == this.$route.name))
      },
      ...mapGetters({
        logged : 'getLogged'
      })
    },
    methods : {
      ...mapActions(['checkLogged','initApp'])
    }
  }
</script>

<style  lang="scss">
@import '@/assets/css/colors.scss';
@import './assets/css/style.scss';
@import './assets/css/responsive.scss';
@import './assets/css/slick.css';
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue